import type { WrittenPage } from '../../sections'

/**
 * The Agentic Readiness Index page in Turkish, written 2026-08-31 alongside the
 * tool's own copy in `content/tools/ari.tr.ts`.
 *
 * The eyebrow is spelled in capitals on purpose, and English keeps the same
 * comment: these labels are uppercased in CSS, CSS casing follows the document
 * language, and under `lang="tr"` the browser maps `i` to `İ` — so left to
 * `text-transform` this product name renders "AGENTİC READİNESS İNDEX".
 *
 * Hub, Core, Agent Core and the product name itself stay English.
 */
export const toolsAri: WrittenPage = {
  navLabel: 'Agentic Readiness Index',
  title: 'Agentic Readiness Index',
  description:
    'Altı boyutta on sekiz soru. İşinizin ne kadarını gerçekten bir AI agent’ının yürütmesine bırakırdınız ve sistemleriniz, iş tarafının çoktan izin verdiği şeyi taşıyabilir mi?',
  sections: [
    {
      kind: 'hero',
      eyebrow: 'AGENTIC READINESS INDEX',
      headline: 'İşinizin ne kadarını gerçekten bir agent’a bırakırdınız?',
      sub: 'Çoğu kurum hedefte, o hedefi güvenli kılan makineden daha ileridedir. Bu araç iki tarafı da puanlıyor — iş tarafınızın neye izin verdiğini ve sistemlerinizin neyi yapabildiğini — sonra aradaki boşluğun adını koyuyor.',
      ctas: [],
    },
    { kind: 'tool', tool: 'agentic-readiness-index' },
    {
      kind: 'prose',
      heading: 'Hub ve Core; neden ikisi birden',
      paragraphs: [
        'Hub, iş tarafının neye izin verdiğidir: ortada mevcut durumu ve sahibi belli, adı konmuş bir değer birimi var mı, kararın ne kadarını gerçekten devrederdiniz ve organizasyon bu değişimi içine sindirebilir mi. Core ise sistemlerin ne yapabildiğidir: bir agent yönetişim altındaki bilgiye erişebiliyor mu, gerçek ana sistemlerinizin içinde iş yapabiliyor mu ve canlıya çıktıktan sonra işletilip izlenip kanıtlanabiliyor mu.',
        'İkisi ayrı puanlanıyor, çünkü başarısızlık biçimleri birbirinin tersi. Yüksek Hub ve düşük Core, güvenle taşıyabileceğinizden fazlasına izin vermek demektir; bir olaya giden en kısa yol budur. Düşük Hub ve yüksek Core ise kimsenin işe yarar bir şeye doğrultmadığı bir kabiliyettir. İkisinin bileşimi olan index de sayfada var; ama birinci değil, üçüncü sayı.',
      ],
    },
  ],
}
